export default "__VITE_ASSET__54OvxS1Y__"